export const FINTECH_META_DESCRIPTION =
  "Media monitoring and media analysis for fintech and banking across SEE - regulation, product launches, reputation and competitive intelligence in one place.";
